import React, { useCallback } from "react"
import { Drawer } from "vaul"

import { GetStartedModalItem } from "./Item"
import { Color } from "../../../../../constants/V2/color"
import TextButton from "../../../../elements/V2/Buttons/TextButton"
import ArrowIcon from "../../../../elements/V2/Icons/ArrowIcon"
import { NeoIcon } from "../../../../elements/V2/Icons/NeoIcon"
import { OrderIcon } from "../../../../elements/V2/Icons/OrderIcon"
import Typography from "../../../../elements/V2/Typography"
import { GetStartedModalTab } from "../Modal"
import { useGetStartedModalStore } from "../store"

const signupUrl = `${process.env.GATSBY_SHOP_SIGNUP_URL || "https://hello.yoco.com/signup"}?userJourney=register_reader`

type GetStartedModalRegisterTabProps = {
  setActiveTab: (tab: GetStartedModalTab) => void
}

export const GetStartedModalRegisterTab = ({
  setActiveTab,
}: GetStartedModalRegisterTabProps) => {
  const { setIsGetStartedModalOpen } = useGetStartedModalStore()

  const handleClick = useCallback(() => {
    setActiveTab("menu")
    setIsGetStartedModalOpen(false)
  }, [setActiveTab, setIsGetStartedModalOpen])

  return (
    <>
      <Drawer.Title className="mb-24 mt-56 flex flex-col gap-8 px-[25px]">
        <Typography
          weight="medium"
          color={Color.Charcoal}
          font="grotesk"
          size="lead-md"
          text="Register a card machine"
        />
        <p>
          <Typography
            weight="book"
            color={Color.Charcoal}
            font="grotesk"
            size="body-md"
            text="If you "
            element="span"
          />
          <Typography
            weight="medium"
            color={Color.Charcoal}
            font="grotesk"
            size="body-md"
            text="did not"
            element="span"
          />
          <Typography
            weight="book"
            color={Color.Charcoal}
            font="grotesk"
            size="body-md"
            text=" get your card machine directly from Yoco, you will need to sign up and register your device."
            element="span"
          />
        </p>

        <Typography
          weight="book"
          color={Color.Charcoal}
          font="grotesk"
          size="body-md"
          text="Select an option below to continue:"
          className="mt-20"
        />
      </Drawer.Title>
      <div className="flex flex-col">
        <GetStartedModalItem
          label="I have my card machine with me"
          icon={NeoIcon}
          link={`${signupUrl}&preSelectedService=reader_registration`}
          onClick={handleClick}
        />
        <GetStartedModalItem
          label="I have an order number via email"
          icon={OrderIcon}
          link={`${signupUrl}&preSelectedService=waiting_for_delivery`}
          onClick={handleClick}
        />
        <div className="flex h-full w-full items-center gap-[6px] border-t border-light-gray px-32 pb-[36px] pt-[31px]">
          <Typography
            font="grotesk"
            size="body-md"
            weight="book"
            text="Already an existing user"
            color={Color.Black}
          />
          <TextButton
            text="login here"
            color={Color.Blue}
            textSize="body-md"
            style="icon"
            icon={
              <div className="overflow-hidden">
                <ArrowIcon
                  width="10px"
                  height="10px"
                  animateOnHover={false}
                  className="-translate-x-6 transition-transform duration-300 group-hover:-translate-x-0"
                />
              </div>
            }
            className="!gap-[5px]"
            linkUrl="https://app.yoco.com/app/business-settings/card-machines"
            onClick={() => setIsGetStartedModalOpen(false)}
          />
        </div>
      </div>
    </>
  )
}
